const urlForPostComment = ({ postId, prefix, params }) => {
	let postUrl = `/post/comments/${postId}`
	if (prefix) {
		postUrl = (prefix[prefix.length - 1] === '/' ? prefix.substr(0, prefix.length - 1) : prefix) + postUrl
	}
	if (params) {
		postUrl += `?${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`
	}
	return postUrl
}

export default urlForPostComment



// WEBPACK FOOTER //
// ./src/utilities/urlForPostComment.js